<template>
  <dx-drop-down-box
    ref="dropDownBox"
    :data-source="periodsList"
    :defer-rendering="false"
    :display-expr="displayExpr"
    :drop-down-options="{ width: 250 }"
    :show-clear-button="showClearButton"
    :value="selectedKeys"
    :width="'100%'"
    placeholder="Период"
    value-expr="id"
    @value-changed="dropDownBoxValueChanged($event)"
  >
    <template>
      <dx-data-grid
        v-model:selected-row-keys="selectedKeys"
        :columns="columns"
        :data-source="periodsList"
        :filter-row="{ visible: true }"
        :height="'50vh'"
        :hover-state-enabled="true"
        :show-column-headers="false"
        key-expr="id"
        @selectionChanged="selectionChanged($event)"
      >
        <dx-selection :mode="selectionMode" />
        <dx-scrolling mode="virtual" />
      </dx-data-grid>
    </template>
  </dx-drop-down-box>
</template>

<script>
export default {
  name: 'mped-calculation-period-component',
};
</script>

<script setup>
import { onMounted, defineEmits, defineModel, defineProps, ref } from 'vue';
import {
  DxDataGrid,
  DxScrolling,
  DxSelection,
} from 'devextreme-vue/data-grid';
import DxDropDownBox from 'devextreme-vue/drop-down-box';

import { getPeriods } from '@/views/mped/services/mped-calculation-service';

const value = defineModel('value');
const columns = [{ caption: 'Период', dataField: 'id', sortOrder: 'desc' }];
const dropDownBox = ref();
const selectedKeys = ref([]);
let periodsList = [];

const emit = defineEmits(['valueChanged']);

const { defaultPeriod, selectionMode, defaultValue, periodFnSource } = defineProps({
  defaultPeriod: {
    type: String,
    default: 'current',
    validator(value) {
      return ['current', 'next', 'prev'].includes(value);
    },
  },
  defaultValue: String,
  selectionMode: {
    type: String,
    default: 'multiple',
  },
  showClearButton: {
    type: Boolean,
    default: true,
  },
  periodFnSource: {
    type: Function
  }
});

onMounted(async () => {
  if (periodFnSource) {
    periodsList = (await periodFnSource()).data;
    selectedKeys.value = defaultValue && [defaultValue] || null;
  } else {
    const periods = getPeriods();
    periodsList = periods.list;
    selectedKeys.value = defaultValue && (Array.isArray(defaultValue) && [...defaultValue] || [defaultValue]) || [periods[defaultPeriod]];
  }
});

const displayExpr = (item) => {
  return item?.id;
};

const selectionChanged = (e) => {
  const ids = e.selectedRowsData.map(x => x.id)
  value.value = ids;
  emit('valueChanged', ids);
  if (selectionMode === 'single') {
    dropDownBox.value.instance.close();
  }
};

const dropDownBoxValueChanged = (e) => {
  if (!e.value) {
    value.value = [];
    selectedKeys.value = [];
  }
};

</script>

<style scoped>

</style>
